enum ListHeaderAlignEnum {
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right',
}

export { ListHeaderAlignEnum };
